import React, { FC, JSX } from 'react';

import { EvContactSupportEmailLink, EvErrorCard } from '@evinced-private/ui-common';

import './FullPageError.scss';

interface IFullPageErrorProps {
	title: string;
}

export const FullPageError: FC<IFullPageErrorProps> = ({ title }: IFullPageErrorProps) => {
	const renderContactUs = (): JSX.Element => {
		return (
			<>
				Please contact us at <EvContactSupportEmailLink />
			</>
		);
	};
	return (
		<div className="full-page-error">
			<EvErrorCard title={title} contactUsMessage={renderContactUs()} />
		</div>
	);
};
